import { Component } from '@angular/core';

@Component({
  selector: 'mtg-svg-icon-definitions',
  templateUrl: './svg-icon-definitions.component.html',
})
export class SvgIconDefinitionsComponent {}
